import getOption from "../../getOption";
import getOptionText from "./getOptionText";
import productHasAlternatePrices from "../../productHasAlternatePrices";
import deriveUniqueVariantsByColour from "./deriveUniqueVariantsByColour";

export default variants => {
  const uniqueVariantsByColour = deriveUniqueVariantsByColour(variants);
  const hasAlternatePrices = productHasAlternatePrices(uniqueVariantsByColour);

  uniqueVariantsByColour.sort(({ colour: a }, { colour: b }) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );

  return uniqueVariantsByColour.map(
    ({ colour, price, isColourInStock, colourWayId }) =>
      getOption(
        getOptionText({
          colour,
          price: hasAlternatePrices ? price : undefined,
          isColourInStock
        }),
        `${colourWayId}`
      )
  );
};
